function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8043"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3027"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 173",
  cx: 17.5,
  cy: 17.5,
  r: 17.5,
  fill: "#e8f6f4"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3029"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2014",
  d: "M17.2 21.844h.913a.31.31 0 00.319-.283v-.717l.085-.019a2.238 2.238 0 001.805-1.793 1.88 1.88 0 00-.595-1.585 2.457 2.457 0 00-1.721-.679h-.7a.8.8 0 01-.573-.226.642.642 0 01-.191-.528.783.783 0 01.807-.6h.807a.468.468 0 01.467.34.314.314 0 00.319.226h.913a.321.321 0 00.234-.094.266.266 0 00.085-.208 1.907 1.907 0 00-1.678-1.6l-.085-.019v-.7a.31.31 0 00-.319-.283h-.913a.31.31 0 00-.319.283v.7l-.085.019a2.115 2.115 0 00-1.805 2.208 2.3 2.3 0 002.4 1.849h.595a.8.8 0 01.573.226.621.621 0 01.191.528.783.783 0 01-.807.6h-.807a.468.468 0 01-.467-.34.314.314 0 00-.319-.226h-.913a.419.419 0 00-.255.094.266.266 0 00-.085.208 1.907 1.907 0 001.678 1.6l.085.019v.7a.353.353 0 00.361.3z",
  fill: "#a1dbd3"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2015",
  d: "M18.444 22.661l.27 1.086a6.78 6.78 0 01-7.723-4.804 5.9 5.9 0 01.553-4.273.337.337 0 00-.137-.458l-1.182-.636a.4.4 0 00-.514.132 7.69 7.69 0 00-.752 5.673c1.051 4.33 5.571 7.046 10.225 6.26l.234.945a.646.646 0 001.049.284l2.97-2.694a.564.564 0 00-.24-.966l-3.938-1.211a.6.6 0 00-.815.662z",
  fill: "#a1dbd3"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2016",
  d: "M14.751 8.132l-2.973 2.695a.564.564 0 00.239.966l3.942 1.208a.612.612 0 00.809-.682l-.27-1.087a6.78 6.78 0 017.724 4.804 5.9 5.9 0 01-.553 4.273.337.337 0 00.137.458l1.187.656a.4.4 0 00.513-.132 7.69 7.69 0 00.753-5.672c-1.073-4.325-5.614-7.036-10.246-6.255l-.235-.946a.628.628 0 00-1.027-.286z",
  fill: "#a1dbd3"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2017",
  d: "M7.511 10.161l19.514 14.591",
  fill: "none",
  stroke: "#a1dbd3",
  strokeLinecap: "round"
})));
var SvgDontRecycleMoneyIconCircle = function SvgDontRecycleMoneyIconCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35"
  }, props), _ref);
};
export default SvgDontRecycleMoneyIconCircle;